export function getZodErrorMessages(schema, values) {
  const result = schema.safeParse(values);
  if (result.success) return [];
  return result.error.issues.map((issue) => issue.message);
}

export function collectRHFErrorMessages(errors) {
  const messages = [];
  const walk = (node) => {
    if (!node) return;
    if (typeof node.message === "string") {
      messages.push(node.message);
      return;
    }
    Object.values(node).forEach(walk);
  };
  walk(errors);
  return [...new Set(messages.filter(Boolean))];
}

export function mergeTopFieldErrors(...groups) {
  return [...new Set(groups.flat().filter(Boolean))];
}
